<template>
    <div class="messagePushInfo">

        <div class="phone">
            <div class="card">
                <div class="content">
                    <p class="name">{{pname}}</p>
                    <p class="time">时间</p>


                    <!--<template v-for="item in datainfo.mptemplatemsglist" v-if="item.code === mpaccountValue && item.innerid === mptemplatemsgValue">-->
                    <p v-for="(columnlist, index) in modulelist">

                        {{columnlist.name}}

                        <span :style="'color:'+columnlist.color" :class="{'firstdata': columnlist.key === 'first','remark': columnlist.key === 'remark'}">
                                <!--<template v-pre>{{</template>-->
                            <!--{{columnlist.key }}-->
                            <!--<template v-pre>}}</template>-->
                                {{ keyValue[index] }}
                            </span>

                        <!---->
                        <!--<p class="txt">-->
                        <!--&lt;!&ndash;<span>&ndash;&gt;-->
                        <!--{{ columnlist.name}}-->
                        <!--<el-input></el-input>-->
                        <!--&lt;!&ndash;</span>&ndash;&gt;-->
                        <!--</p>-->
                        <!--<p>字体颜色</p>-->
                        <!--<el-color-picker v-model="colorlist[index]"></el-color-picker>-->
                        <!--<el-button @click="clear(index)">重置</el-button>-->
                    </p>
                    <!--</template>-->
                    <p style="color: #00a0e9">链接</p>

                    <!---->
                    <!---->
                    <!---->
                    <!--<p v-for="(columnlist,index) in datainfo.columnlist">-->
                        <!--{{columnlist.name}}-->
                        <!--<span :style="'color:'+colorlist[index]" :class="{'firstdata':index===0,'remark':index===3}">-->
                            <!--<template v-pre>{{</template>-->
                            <!--{{columnlist.key }}-->
                            <!--<template v-pre>}}</template>-->
                        <!--</span>-->
                    <!--</p>-->
                </div>
                <div class="goto">详情 <span>></span></div>
            </div>
        </div>
        <div class="info">

            <div>
                <p class="name">基本信息</p>
                <div class="item">
                    <p>信息名称 <span>*</span></p>
                    <ul>
                        <el-input v-model="messagename" placeholder="请输入信息名称" maxlength="20" show-word-limit></el-input>
                    </ul>
                </div>
                <div class="item">
                    <p>消息类型 <span>*</span></p>
                    <ul>
                        <el-select v-model="msgtypeValue" placeholder="请选择" :disabled="disabled" @change="msgselect">
                            <el-option v-for="item in datainfo.msgtypelist" :key="item.msgtype" :value="item.msgtype" :label="item.msgtypename"></el-option>
                        </el-select>

                        <p style="margin-top: 10px" v-if="msgconfig !== ''">变量：{{msgconfig.paramslist}}</p>
                    </ul>
                </div>
            </div>

            <div>
                <p class="name">推送消息详情</p>
                <div class="item">
                    <p>公众号 <span>*</span></p>
                    <ul>
                        <el-select v-model="mpaccountValue" @change="mptemplatemsgValue = '',modulelist = ''" :disabled="disabled">
                            <el-option v-for="item in datainfo.mpaccountlist" :value="item.code" :key="item.code" :label="item.paname"></el-option>
                        </el-select>
                    </ul>
                </div>
                <div class="item">
                    <p>选择模版 <span>*</span></p>
                    <ul>
                        <el-select v-model="mptemplatemsgValue" @change="selectModule" :disabled="disabled">
                            <el-option v-for="item in datainfo.mptemplatemsglist" v-if="item.code === mpaccountValue" :value="item.innerid" :key="item.innerid" :label="item.name"></el-option>
                        </el-select>
                    </ul>
                </div>

                <!--<template v-for="item in datainfo.mptemplatemsglist" v-if="item.code === mpaccountValue && item.innerid === mptemplatemsgValue">-->
                    <div class="item" v-for="(columnlist, index) in modulelist">
                        <p v-if="columnlist.key === 'first'">消息开头:</p>
                        <p v-else-if="columnlist.key === 'remark'">备注:</p>
                        <p v-else>{{ columnlist.name }}</p>
                        <ul>
                            <el-input v-model="keyValue[index]"></el-input>
                            <div class="color">
                                <p class="color-item">字体颜色</p>
                                <el-color-picker v-model="columnlist.color" class="color-item"></el-color-picker>
                                <el-button @click="clear(index)" class="color-item">重置</el-button>
                            </div>
                        </ul>
                    </div>
                <!--</template>-->

                <div class="item">
                    <p>跳转链接 <span>*</span></p>
                    <ul>
                        <el-select v-model="hrefValue" placeholder="选择跳转链接">
                            <el-option v-for="item in datainfo.linkurltypelist" :value="item.linkurltype" :label="item.linkurltypename" :key="item.linkurltype"></el-option>
                        </el-select>

                        <el-input v-if="hrefValue === 99" style="margin-top: 10px" v-model="hrefname" placeholder="输入自定义链接"></el-input>
                    </ul>
                </div>
            </div>

            <div class="item">
                <div class="btn">
                    <el-button @click="back()">取消</el-button>
                    <el-button type="primary" @click="submit()">保存</el-button>
                </div>
            </div>
        </div>

    </div>
</template>


<!--
contentlist: "[{"keycolor":"#173176","keyid":"first","keyname":"","keyvalue":""},{"keycolor":"#173177","keyid":"keyword1","keyname":"","keyvalue":"活动名称"},{"keycolor":"#173177","keyid":"keyword2","keyname":"","keyvalue":"活动时间"},{"keycolor":"#173177","keyid":"keyword3","keyname":"","keyvalue":"活动地点"},{"keycolor":"#173177","keyid":"remark","keyname":"","keyvalue":""}]" 
innerid: "jliCaemvjQQavI2a"  //消息推送模版innerid 
linkurl: "http://www.baidu.com"	// 跳转地址Url 
linkurltype: 1 // 默认跳转地址类型 
 linkurltypename: "商品详情" // 默认跳转地址类型文本
 msgname: "重要通知" // 消息名称
  msgtype: 1 // 消息类型 
 msgtypename: "购买成功通知-通知购买人" //消息类型文本  
 painnerid: "b9eea17e731f4347ae7e631c526fd579"  //公众号 innerid 
 paname: "蓝鲸会Club"  //所属公众号名称
  tmplname: "活动报名成功通知" // 模板名称   
-->


<script>
    import {updateMpmessageTemplateColor, findMpmessageTemplateInfo, getMpmessageconfig, saveAndUpdateHostmpmessageconfig, getHostMessageConfig} from '@/api/accountApi'
    import Loading from 'base/loading/loading'    // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: "messagePushInfo",
        data() {
            return {
                innerid: this.$route.query.innerid,
                disabled: false,    // 禁止文本
                token: JSON.parse(sessionStorage['user']).loginToken, // token
                shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
                sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
                datainfo: [],
                messagename: '', // 消息名称
                hrefValue: '',  // 跳转链接
                mpaccountValue: '', // 公众号
                mptemplatemsgValue: '', // 模版
                msgtypeValue: '', // 消息类型
                modulelist: [], // 模版数据
                clearmodulelist: [], // 默认模版数据
                keyValue: [],   // 模版动态消息信息
                hrefname: '',
                msgconfiglist: [], // 模版基本信息配置 如果存在
                msgconfig: '',  // 模版基本信息配置内容
                getHost: {},
                pname: ''
            }
        },
        mounted() {
            // 获取初始化配置信息
            var data = {
                // LoginToken: this.token,
                // ShopID: this.shopID,
                ClientType: 3,
                // page: this.page,
                // pageSize: 10
            }
            this.setLoading(true)
            // 配置信息列表
            getMpmessageconfig({
                data: data,
                success:data => {
                    this.setLoading(false)
                    console.log(data)
                    this.datainfo = data.data

                    // 当前页面不为编辑页面时 执行该选择
                    if (!this.innerid) {
                        this.msgconfiglist = this.datainfo.msgconfiglist
                        console.log(this.msgconfiglist)
                    }
                },
                error:data => {
                    this.setLoading(false)
                }
            })

            // innerid 存在进入编辑页面状态
            this.bianji()

        },
        methods: {
            just() {
                // 为空判断
                if (this.messagename.length < 1) {
                    this.$message.error('消息名称不能为空')
                    return false
                } else if (this.mpaccountValue.length < 1) {
                    this.$message.error('请选择公众号')
                    return false
                } else if (this.mptemplatemsgValue.length < 1) {
                    this.$message.error('请选择模版')
                    return false
                } else if (this.hrefValue.length < 1) {
                    this.$message.error('请选择跳转链接')
                    return false
                } else if (this.msgtypeValue.length < 1) {
                    this.$message.error('请选择消息类型')
                    return false
                }
            },
            back() {
                this.$router.go(-1)
            },
            submit() {

                if (this.just() == false)
                    return

                var mpaccountlist = this.datainfo.mpaccountlist,
                    mpaccountValue = this.mpaccountValue,
                    modulelist = this.modulelist,
                    pacode = '',
                    contentlist = [],
                    keyValue = this.keyValue


                // 获取列表模版数据
                for (var i = 0; i < modulelist.length; i++ ) {
                    contentlist.push({
                        'keyname': modulelist[i].name,
                        'keycolor': modulelist[i].color,
                        'keyid': modulelist[i].key,
                        'keyvalue': keyValue[i]
                    })

                }

                // 添加推送消息
                var data = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    ClientType: 1,
                    msgname: this.messagename, // 信息名称
                    msgtype: this.msgtypeValue, // 消息类型
                    pacode: mpaccountValue, // 公众号id
                    tmplinnerid: this.mptemplatemsgValue, // 模版id
                    linkurltype: this.hrefValue, // 默认跳转地址类型
                    linkurl: this.hrefValue === 99?this.hrefname:'', // 跳转地址url
                    contentlist: JSON.stringify(contentlist) // 串
                }

                // 如果是编辑状态下页面 则进行调整
                if (this.innerid) {
                    data.innerid = this.getHost.innerid
                    // data.msgtype = this.getHost.msgtype // 消息类型
                    // data.pacode = this.getHost.painnerid    // 公众号id
                    // data.tmplinnerid = this.getHost.innerid // 模版id
                }

                console.log(data)
                this.setLoading(true)
                saveAndUpdateHostmpmessageconfig({
                    data: data,
                    success:data => {

                        this.setLoading(false)
                        this.$message.success('保存成功')

                        if (this.innerid) {
                            this.bianji()
                        } else {
                            // 新增时返回
                            this.back()
                        }

                    },
                    error:data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            selectModule(value) {
                console.log(value)

                // 选择模版后操作 取得模版数据
                for (var i = 0; i < this.datainfo.mptemplatemsglist.length; i++ ) {
                    if (this.datainfo.mptemplatemsglist[i].code === this.mpaccountValue && this.datainfo.mptemplatemsglist[i].innerid === this.mptemplatemsgValue) {
                        this.modulelist = this.datainfo.mptemplatemsglist[i].columnlist
                        this.clearmodulelist = JSON.parse(JSON.stringify(this.modulelist))

                        this.pname = this.datainfo.mptemplatemsglist[i].name
                    }
                }
                this.keyValue = []
                this.initfirstandmarkti()
                //
                // console.log(this.keyValue)

                // console.log(value)
                // console.log(1)
            },
            clear(index) {
                var datainfocolor = this.clearmodulelist
                for (var i = 0; i <  datainfocolor.length; i++) {
                    if (index === i) {
                        this.modulelist[i].color = datainfocolor[i].color
                    }
                }
                Object.assign({},this.modulelist)
            },
            bianji() {
                if (this.innerid) {
                    this.disabled = true
                    var adddata = {
                        // LoginToken: this.token,
                        // ShopID: this.shopID,
                        ClientType: 3,
                        innerid: this.innerid
                    }
                    this.setLoading(true)
                    getHostMessageConfig({
                        data: adddata,
                        success:data => {
                            console.log(data)
                            this.setLoading(false)

                            // 编辑时刷新
                            this.modulelist = []
                            this.clearmodulelist = []
                            this.keyValue = []
                            this.hrefname = ''

                            // 配置初始化信息
                            var init = this. getHost = data.data

                            // 消息名称
                            this.messagename = init.msgname

                            // 消息配置
                            this.msgtypeValue = init.msgtype

                            // 公众号配置
                            this.mpaccountValue = init.pacode

                            // 模版配置
                            this.mptemplatemsgValue = init.tmplinnerid

                            // 地址配置
                            this.hrefValue = init.linkurltype
                            // 如果是自定义地址则展示配置
                            if (this.hrefValue === 99) {
                                this.hrefname = init.linkurl
                            }

                            var contentlist = JSON.parse(init.contentlist)
                            // 获取列表模版数据
                            for (var i = 0; i < contentlist.length; i++ ) {
                                this.modulelist.push({
                                    'name': contentlist[i].keyname,
                                    'color': contentlist[i].keycolor,
                                    'key': contentlist[i].keyid
                                })
                                this.keyValue[i] = contentlist[i].keyvalue
                            }
                            this.clearmodulelist = JSON.parse(JSON.stringify(this.modulelist))
                            // console.log(init.contentlist)
                            // console.log(this.keyValue)

                        },
                        error:data => {
                            console.log('error getHostMessageConfig')
                            this.setLoading(false)
                        }
                    })

                }
            },
            msgselect(value) {

                //初始化数据
                this.msgconfig = ''

                // 消息选择
                for (var i = 0; i < this.msgconfiglist.length; i++) {
                    if (this.msgconfiglist[i].msgtype === this.msgtypeValue) {
                        this.msgconfig = this.msgconfiglist[i]
                    }
                }
                this.initfirstandmarkti()
            },
            initfirstandmarkti(){
                // 调整默认配置
                for (var i = 0; i < this.modulelist.length; i++) {
                    if (this.modulelist[i].key === 'first') {
                        this.keyValue[i] = this.msgconfig.firstcontent
                        console.log('fitsr')
                    } else if (this.modulelist[i].key === 'remark') {
                        this.keyValue[i] = this.msgconfig.remarkcontent
                        console.log('remark')
                    }
                }

            },
            ...mapActions ([
                'setLoading'
            ])
        },
        components: {Loading}
    }
</script>

<style lang="scss" type="text/scss">
    .publicNumber {
        min-width: 1200px;
    }
    .messagePushInfo {
        overflow: hidden;

        .el-select {
            width: 100%;
            .el-input__icon {
                line-height: normal;
            }
        }
        .phone {
            float: left;
            display: block;
            position: relative;
            width: 406px;
            height: 782px;
            background: url("../../../common/images/accountmgt/white.png") no-repeat;
            background-size: 406px 782px;

            .card {
                position: absolute;
                margin: auto;
                top: 157px;
                left: 0;
                right: 0;
                width: 294px;
                height: 248px;
                background: #fff;

                .content {
                    padding: 10px;
                    height: 214px;
                    box-sizing: border-box;

                    p {
                        margin-top: 6px;
                        font-size: 13px;
                    }
                    .name {
                        font-size: 18px;
                        color: #000;
                        font-weight: bold;
                    }
                    .time {
                        font-size: 13px;
                        color: #909399;
                    }
                    .firstdata {
                        display: block;
                        margin-top: 9px;
                        margin-bottom: 15px;
                    }
                    .remark {
                        display: block;
                        margin-top: 30px;
                    }
                }
                .goto {
                    padding: 0 10px;
                    line-height: 34px;
                    font-size: 13px;
                    border-top: solid 1px #eee;
                    span {
                        float: right;
                        color: #ccc;
                        text-align: right;
                    }
                }
            }
        }
        .item {
            position: relative;
            margin-bottom: 30px;
            min-height: 13px;
            height: 32px;

            ul {
                clear: both;
                display: inline-block;
                margin-top: -10px;
                width: 440px;
                li {
                    margin-bottom: 25px;
                    height: 50px;
                    overflow: hidden;
                    border-bottom: solid 1px #DCDFE6;

                    p {
                        float: left;
                        margin-right: 20px;
                        line-height: 30px;
                        color: #303133 !important;
                    }

                    p.txt {
                        width: 200px;
                        color: #606266;
                    }

                    .el-color-picker__trigger {
                        width: 60px;
                        height: 30px;
                    }
                    .el-color-picker,
                    .el-button {
                        float: left;
                        min-width: 60px;
                        width: 60px;
                        height: 30px;
                        border-radius: 0;
                    }

                    .el-button {
                        margin-left: 20px;
                    }

                }
                .color {
                    position: absolute;
                    margin: auto;
                    right: -270px;
                    top: -9px;
                    height: 30px;

                    p.color-item { text-align: right;}
                    .color-item {
                        float: left;
                        line-height: 32px;
                        margin-right: 20px;
                    }
                    .el-button, .el-button--mini,
                    .el-color-picker__trigger {
                        min-width: 60px;
                        width: 60px;
                        height: 30px;
                    }

                }
            }
            p {
                float: left;
                display: block;
                min-width: 80px;
                height: 100%;
                font-size: 14px;
            }
            p:nth-child(2) {
                color: #606266;
            }
        }
        .btn {
            margin-left: 80px;
            margin-top: 50px;
        }
        .info {
            float: left;
            margin-top: 30px;

            p.name {
                margin-bottom: 20px;
                padding-left: 8px;
                font-size: 16px;
                color: #303133;
                font-weight: 500;
                border-left: solid 2px #00a0e9;
            }
            p span {
                color: #FA5555;
            }
        }
    }
</style>
